import { formatNum } from '@/utils';
import { UnionBadge } from '../types';

export const transBadge = (badge: UnionBadge) => {
  badge._total_supply = formatNum(badge.total_supply, 0);

  return badge;
};
